import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronLeft, Settings, Menu } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';

/**
 * Header component for app navigation with fitness app styling
 */
const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { tournament } = useAppContext();

  // Go back to previous page
  const goBack = () => {
    navigate(-1);
  };

  // Go to settings
  const goToSettings = () => {
    navigate('/settings');
  };

  // Get the title based on the current route
  const getTitle = () => {
    const path = location.pathname;
    if (path === '/schedule') return 'Schedule';
    if (path.startsWith('/match/')) return 'Match';
    if (path === '/teams') return 'Teams';
    if (path === '/leaderboard') return 'Standings';
    if (path === '/past-matches') return 'Match History';
    if (path === '/analytics') return 'Statistics';
    if (path === '/settings') return 'Settings';

    return tournament?.name || 'TourneyPro';
  };

  return (
    <header className="bg-white dark:bg-gray-900 border-b border-gray-100 dark:border-gray-800 sticky top-0 z-10 pt-safe">
      <div className="max-w-xl mx-auto flex justify-between items-center h-16">
        <div className="flex items-center">
        <button
          onClick={goBack}
            className="p-3 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-600 dark:text-gray-300 transition-colors"
          aria-label="Go back"
        >
            <ChevronLeft strokeWidth={2.5} size={22} />
        </button>
        </div>

        <div className="text-center absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <h1 className="font-display font-semibold text-lg tracking-wide text-gray-900 dark:text-white">
            {getTitle()}
          </h1>
        </div>

        <div className="flex items-center space-x-1">
        <button
          onClick={goToSettings}
            className="p-3 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-600 dark:text-gray-300 transition-colors"
          aria-label="Settings"
        >
            <Settings strokeWidth={2} size={22} />
          </button>

          <button
            className="p-3 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-600 dark:text-gray-300 transition-colors"
            aria-label="Menu"
          >
            <Menu strokeWidth={2} size={22} />
        </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
